/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cube Internal API
 * Internal API for React frontend consumption
 * OpenAPI spec version: 1.0.0 (app)
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuthOidcCallbackParams,
  AuthOidcStartParams,
  BffError,
  ChangePasswordRequestRequest,
  ChangePasswordResponse,
  LoginRequestRequest,
  LoginResponse,
  OidcStartResponse,
  RequestPasswordResetRequestRequest,
  RequestPasswordResetResponse,
  SendSmsTokenResponse,
  SetNewPasswordRequestRequest,
  SetNewPasswordResponse,
  VerifyAppTokenRequestRequest,
  VerifySmsTokenRequestRequest
} from '../schemas';

import { custom_instance } from '../../axios-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Validates the current password and updates to a new password using Django's `PasswordChangeForm`. On success, navigate to `redirect_url`.
 * @summary Change password for logged-in user
 */
export const authChangePassword = (
    changePasswordRequestRequest: ChangePasswordRequestRequest,
 signal?: AbortSignal
) => {


      return custom_instance<ChangePasswordResponse>(
      {url: `/app/bff/auth/change_password/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changePasswordRequestRequest, signal
    },
      );
    }




export const getAuthChangePasswordMutationOptions = <TError = BffError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authChangePassword>>, TError,AuthChangePasswordMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authChangePassword>>, TError,AuthChangePasswordMutationVariables, TContext> => {

const mutationKey = ['authChangePassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authChangePassword>>, AuthChangePasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authChangePassword(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authChangePassword>>>
    export type AuthChangePasswordMutationBody = ChangePasswordRequestRequest
    export type AuthChangePasswordMutationError = BffError
    export type AuthChangePasswordMutationVariables = {data: ChangePasswordRequestRequest}

    /**
 * @summary Change password for logged-in user
 */
export const useAuthChangePassword = <TError = BffError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authChangePassword>>, TError,AuthChangePasswordMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authChangePassword>>,
        TError,
        AuthChangePasswordMutationVariables,
        TContext
      > => {
      return useMutation(getAuthChangePasswordMutationOptions(options), queryClient);
    }
    /**
 * Validates credentials and either logs the user in (creating the session) or queues the user for two-factor verification. The React client should navigate to `redirect_url` via `window.location.href` after a 200 response.
 * @summary Authenticate with email and password
 */
export const authLogin = (
    loginRequestRequest: LoginRequestRequest,
 signal?: AbortSignal
) => {


      return custom_instance<LoginResponse>(
      {url: `/app/bff/auth/login/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequestRequest, signal
    },
      );
    }




export const getAuthLoginMutationOptions = <TError = BffError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,AuthLoginMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,AuthLoginMutationVariables, TContext> => {

const mutationKey = ['authLogin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogin>>, AuthLoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authLogin(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authLogin>>>
    export type AuthLoginMutationBody = LoginRequestRequest
    export type AuthLoginMutationError = BffError
    export type AuthLoginMutationVariables = {data: LoginRequestRequest}

    /**
 * @summary Authenticate with email and password
 */
export const useAuthLogin = <TError = BffError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,AuthLoginMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authLogin>>,
        TError,
        AuthLoginMutationVariables,
        TContext
      > => {
      return useMutation(getAuthLoginMutationOptions(options), queryClient);
    }
    /**
 * Browser callback from Microsoft Entra. On success, creates a Cube session (Cube 2FA is skipped for SSO) and redirects to the post-login URL. On failure, redirects back to the login page with an error query parameter.
 * @summary Complete Microsoft Entra OIDC login
 */
export const authOidcCallback = (
    params: AuthOidcCallbackParams,
 signal?: AbortSignal
) => {


      return custom_instance<unknown>(
      {url: `/app/bff/auth/oidc/callback/`, method: 'GET',
        params, signal
    },
      );
    }




export const getAuthOidcCallbackQueryKey = (params?: AuthOidcCallbackParams,) => {
    return [
    `/app/bff/auth/oidc/callback/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuthOidcCallbackQueryOptions = <TData = Awaited<ReturnType<typeof authOidcCallback>>, TError = void | BffError>(params: AuthOidcCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authOidcCallback>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthOidcCallbackQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authOidcCallback>>> = ({ signal }) => authOidcCallback(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authOidcCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthOidcCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof authOidcCallback>>>
export type AuthOidcCallbackQueryError = void | BffError


export function useAuthOidcCallback<TData = Awaited<ReturnType<typeof authOidcCallback>>, TError = void | BffError>(
 params: AuthOidcCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authOidcCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authOidcCallback>>,
          TError,
          Awaited<ReturnType<typeof authOidcCallback>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthOidcCallback<TData = Awaited<ReturnType<typeof authOidcCallback>>, TError = void | BffError>(
 params: AuthOidcCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authOidcCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authOidcCallback>>,
          TError,
          Awaited<ReturnType<typeof authOidcCallback>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthOidcCallback<TData = Awaited<ReturnType<typeof authOidcCallback>>, TError = void | BffError>(
 params: AuthOidcCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authOidcCallback>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Complete Microsoft Entra OIDC login
 */

export function useAuthOidcCallback<TData = Awaited<ReturnType<typeof authOidcCallback>>, TError = void | BffError>(
 params: AuthOidcCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authOidcCallback>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthOidcCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns the Microsoft Entra authorize URL when SSO is enabled for the tenant. The React client should navigate to `authorize_url` via `window.location.href`.
 * @summary Start Microsoft Entra OIDC login
 */
export const authOidcStart = (
    params?: AuthOidcStartParams,
 signal?: AbortSignal
) => {


      return custom_instance<OidcStartResponse>(
      {url: `/app/bff/auth/oidc/start/`, method: 'GET',
        params, signal
    },
      );
    }




export const getAuthOidcStartQueryKey = (params?: AuthOidcStartParams,) => {
    return [
    `/app/bff/auth/oidc/start/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuthOidcStartQueryOptions = <TData = Awaited<ReturnType<typeof authOidcStart>>, TError = BffError>(params?: AuthOidcStartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authOidcStart>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthOidcStartQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authOidcStart>>> = ({ signal }) => authOidcStart(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authOidcStart>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthOidcStartQueryResult = NonNullable<Awaited<ReturnType<typeof authOidcStart>>>
export type AuthOidcStartQueryError = BffError


export function useAuthOidcStart<TData = Awaited<ReturnType<typeof authOidcStart>>, TError = BffError>(
 params: undefined |  AuthOidcStartParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authOidcStart>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authOidcStart>>,
          TError,
          Awaited<ReturnType<typeof authOidcStart>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthOidcStart<TData = Awaited<ReturnType<typeof authOidcStart>>, TError = BffError>(
 params?: AuthOidcStartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authOidcStart>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authOidcStart>>,
          TError,
          Awaited<ReturnType<typeof authOidcStart>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthOidcStart<TData = Awaited<ReturnType<typeof authOidcStart>>, TError = BffError>(
 params?: AuthOidcStartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authOidcStart>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Start Microsoft Entra OIDC login
 */

export function useAuthOidcStart<TData = Awaited<ReturnType<typeof authOidcStart>>, TError = BffError>(
 params?: AuthOidcStartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authOidcStart>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthOidcStartQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Queues a password-reset email when the account exists and is allowed to reset. Always returns the same success response to avoid email enumeration. On success, navigate to `redirect_url` (the validated `success_url`).
 * @summary Request password reset email
 */
export const authRequestPasswordReset = (
    requestPasswordResetRequestRequest: RequestPasswordResetRequestRequest,
 signal?: AbortSignal
) => {


      return custom_instance<RequestPasswordResetResponse>(
      {url: `/app/bff/auth/request_password_reset/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestPasswordResetRequestRequest, signal
    },
      );
    }




export const getAuthRequestPasswordResetMutationOptions = <TError = BffError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRequestPasswordReset>>, TError,AuthRequestPasswordResetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authRequestPasswordReset>>, TError,AuthRequestPasswordResetMutationVariables, TContext> => {

const mutationKey = ['authRequestPasswordReset'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRequestPasswordReset>>, AuthRequestPasswordResetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authRequestPasswordReset(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthRequestPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof authRequestPasswordReset>>>
    export type AuthRequestPasswordResetMutationBody = RequestPasswordResetRequestRequest
    export type AuthRequestPasswordResetMutationError = BffError
    export type AuthRequestPasswordResetMutationVariables = {data: RequestPasswordResetRequestRequest}

    /**
 * @summary Request password reset email
 */
export const useAuthRequestPasswordReset = <TError = BffError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRequestPasswordReset>>, TError,AuthRequestPasswordResetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authRequestPasswordReset>>,
        TError,
        AuthRequestPasswordResetMutationVariables,
        TContext
      > => {
      return useMutation(getAuthRequestPasswordResetMutationOptions(options), queryClient);
    }
    /**
 * Generates a fresh one-time code and dispatches it via SMS to the phone number on file for the user whose credentials were already accepted by `/app/bff/auth/login/`. The React `verify_sms_token` screen calls this endpoint on mount and again when the user clicks the resend button. The request body is empty — the user is identified by the queued username in the session.
 * @summary Send (or resend) the SMS one-time code
 */
export const authSendSmsToken = (

 signal?: AbortSignal
) => {


      return custom_instance<SendSmsTokenResponse>(
      {url: `/app/bff/auth/send_sms_token/`, method: 'POST', signal
    },
      );
    }




export const getAuthSendSmsTokenMutationOptions = <TError = BffError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authSendSmsToken>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authSendSmsToken>>, TError,void, TContext> => {

const mutationKey = ['authSendSmsToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authSendSmsToken>>, void> = () => {


          return  authSendSmsToken()
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthSendSmsTokenMutationResult = NonNullable<Awaited<ReturnType<typeof authSendSmsToken>>>

    export type AuthSendSmsTokenMutationError = BffError


    /**
 * @summary Send (or resend) the SMS one-time code
 */
export const useAuthSendSmsToken = <TError = BffError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authSendSmsToken>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authSendSmsToken>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAuthSendSmsTokenMutationOptions(options), queryClient);
    }
    /**
 * Validates the uid/token pair and updates the user's password using Django's `SetPasswordForm`. On success, navigate to `redirect_url`.
 * @summary Set new password from email reset link
 */
export const authSetNewPassword = (
    setNewPasswordRequestRequest: SetNewPasswordRequestRequest,
 signal?: AbortSignal
) => {


      return custom_instance<SetNewPasswordResponse>(
      {url: `/app/bff/auth/set_new_password/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setNewPasswordRequestRequest, signal
    },
      );
    }




export const getAuthSetNewPasswordMutationOptions = <TError = BffError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authSetNewPassword>>, TError,AuthSetNewPasswordMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authSetNewPassword>>, TError,AuthSetNewPasswordMutationVariables, TContext> => {

const mutationKey = ['authSetNewPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authSetNewPassword>>, AuthSetNewPasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authSetNewPassword(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthSetNewPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authSetNewPassword>>>
    export type AuthSetNewPasswordMutationBody = SetNewPasswordRequestRequest
    export type AuthSetNewPasswordMutationError = BffError
    export type AuthSetNewPasswordMutationVariables = {data: SetNewPasswordRequestRequest}

    /**
 * @summary Set new password from email reset link
 */
export const useAuthSetNewPassword = <TError = BffError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authSetNewPassword>>, TError,AuthSetNewPasswordMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authSetNewPassword>>,
        TError,
        AuthSetNewPasswordMutationVariables,
        TContext
      > => {
      return useMutation(getAuthSetNewPasswordMutationOptions(options), queryClient);
    }
    /**
 * Completes the two-factor flow for users whose credentials were already accepted by `/app/bff/auth/login/`. Reads the queued username from the session, validates the 6-digit TOTP code, and on success creates the fully authenticated session. The React client should navigate to `redirect_url` via `window.location.href` after a 200 response.
 * @summary Verify Authenticator-app TOTP token
 */
export const authVerifyAppToken = (
    verifyAppTokenRequestRequest: VerifyAppTokenRequestRequest,
 signal?: AbortSignal
) => {


      return custom_instance<LoginResponse>(
      {url: `/app/bff/auth/verify_app_token/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyAppTokenRequestRequest, signal
    },
      );
    }




export const getAuthVerifyAppTokenMutationOptions = <TError = BffError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authVerifyAppToken>>, TError,AuthVerifyAppTokenMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authVerifyAppToken>>, TError,AuthVerifyAppTokenMutationVariables, TContext> => {

const mutationKey = ['authVerifyAppToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authVerifyAppToken>>, AuthVerifyAppTokenMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authVerifyAppToken(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthVerifyAppTokenMutationResult = NonNullable<Awaited<ReturnType<typeof authVerifyAppToken>>>
    export type AuthVerifyAppTokenMutationBody = VerifyAppTokenRequestRequest
    export type AuthVerifyAppTokenMutationError = BffError
    export type AuthVerifyAppTokenMutationVariables = {data: VerifyAppTokenRequestRequest}

    /**
 * @summary Verify Authenticator-app TOTP token
 */
export const useAuthVerifyAppToken = <TError = BffError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authVerifyAppToken>>, TError,AuthVerifyAppTokenMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authVerifyAppToken>>,
        TError,
        AuthVerifyAppTokenMutationVariables,
        TContext
      > => {
      return useMutation(getAuthVerifyAppTokenMutationOptions(options), queryClient);
    }
    /**
 * Completes the two-factor flow for users whose credentials were already accepted by `/app/bff/auth/login/` and who received an SMS code via `/app/bff/auth/send_sms_token/`. Reads the queued username from the session, validates the code, and on success creates the fully authenticated session. The React client should navigate to `redirect_url` via `window.location.href` after a 200 response.
 * @summary Verify SMS one-time code
 */
export const authVerifySmsToken = (
    verifySmsTokenRequestRequest: VerifySmsTokenRequestRequest,
 signal?: AbortSignal
) => {


      return custom_instance<LoginResponse>(
      {url: `/app/bff/auth/verify_sms_token/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifySmsTokenRequestRequest, signal
    },
      );
    }




export const getAuthVerifySmsTokenMutationOptions = <TError = BffError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authVerifySmsToken>>, TError,AuthVerifySmsTokenMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authVerifySmsToken>>, TError,AuthVerifySmsTokenMutationVariables, TContext> => {

const mutationKey = ['authVerifySmsToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authVerifySmsToken>>, AuthVerifySmsTokenMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authVerifySmsToken(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthVerifySmsTokenMutationResult = NonNullable<Awaited<ReturnType<typeof authVerifySmsToken>>>
    export type AuthVerifySmsTokenMutationBody = VerifySmsTokenRequestRequest
    export type AuthVerifySmsTokenMutationError = BffError
    export type AuthVerifySmsTokenMutationVariables = {data: VerifySmsTokenRequestRequest}

    /**
 * @summary Verify SMS one-time code
 */
export const useAuthVerifySmsToken = <TError = BffError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authVerifySmsToken>>, TError,AuthVerifySmsTokenMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authVerifySmsToken>>,
        TError,
        AuthVerifySmsTokenMutationVariables,
        TContext
      > => {
      return useMutation(getAuthVerifySmsTokenMutationOptions(options), queryClient);
    }
